<template>
  <div class="showData-wrap">
    <i class="result"></i>
    <div class="match-result-img" :class="{
        'not-match-result': propData.IS_MATCH == '0',
        'matched-result': propData.IS_MATCH == '1',
      }"></div>
    <header class="title">{{ propData.title }}</header>
    <article class="">
      <div class="message">
        <i class="el-icon el-icon-warning"></i>{{ propData.message }}
      </div>
      <div class="data-wrap" v-for="v in propData.listData" :key="v.title">
        <header class="list-title">
          <normal-title :field="{
              FIELD_TITLE: v.title,
              style: `color:#808992;`,
            }" font_size="0.13rem"></normal-title>
        </header>
        <section class="list-table">
          <div class="list-item flex" v-for="item in v.list" :key="item.title">
            <div class="item-key">{{ item.key }}</div>
            <div class="item-value" :class="{ active: item.active == '1' }">
              {{ item.value }}
            </div>
          </div>
        </section>
      </div>
    </article>
  </div>
</template>
<script>
import normalTitle from "@/components/preEntry/normalTitle";
export default {
  name: "showData",
  data () {
    return {

    };
  },
  components: {
    "normal-title": normalTitle
  },
  props: {
    propData: {
      type: Object,
      default: {
        title: "账户资料核对",
        listData: [],//[{title:'TA账户资料',list:[{key:value}]}]
        IS_MATCH: "0", // 0 不匹配 1 匹配
        message: "", //提示信息
        actives: [] //需要高亮的key
      }
    }
  },
};
</script>
<style lang="less" scoped>
.showData-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 72px 138px;
  .title {
    margin-bottom: 50px;
    font-size: 50px;
    font-weight: bold;
    text-align: center;
  }
  .message {
    position: relative;
    padding-left: 20px;
    font-size: 24px;
    color: #ff6c00;
    line-height: 1.4;
    .el-icon {
      position: absolute;
      top: 4px;
      left: -10px;
    }
  }
  .data-wrap {
    margin-top: 40px;
    font-size: 24px;
    .list-table {
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      border-left: 2px solid #cacdd7;
      border-bottom: 2px solid #cacdd7;
      .list-item {
        width: 50%;
        border-top: 2px solid #cacdd7;
        .item-key {
          width: 30%;
          padding: 20px 34px;
          border-right: 2px solid #cacdd7;
          color: #808992;
          text-align: center;
          background-color: #f0f3f8;
        }
        .item-value {
          width: 70%;
          padding: 20px 34px;
          border-right: 2px solid #cacdd7;
          color: #818488;
          &.active {
            color: #bd2e2e;
          }
        }
      }
    }
  }
  .match-result-img {
    position: absolute;
    top: 265px;
    right: 60px;
    display: block;
    width: 286px;
    height: 248px;
    &.not-match-result {
      background: url("~@img/business/inconformity.png") no-repeat center;
      background-size: 100% auto;
    }
    &.matched-result {
      background: url("~@img/suitability/pass/pic_pipei.png") no-repeat center;
      background-size: 100% auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/lib/ui/default/popup/src/content/showData.vue